import React from 'react';
export class PlayerUIVisibilityManager extends React.Component {
    UNSAFE_componentWillReceiveProps({ isPlayerUIVisible, showPlayerUI, hidePlayerUI, }) {
        if (isPlayerUIVisible !== this.props.isPlayerUIVisible) {
            isPlayerUIVisible // eslint-disable-line no-unused-expressions
                ? showPlayerUI && showPlayerUI()
                : hidePlayerUI && hidePlayerUI();
        }
    }
    render() {
        return null;
    }
}
//# sourceMappingURL=ui-visibility-manager.js.map